<template>
  <div class="block">
    <h4 class="title is-4">Knowledgebase Articles</h4>
    <p class="subtitle is-5">See all knowledgebase articles for LOW.MS.</p>
    <b-table :data="knowledgebases">
      <b-table-column v-slot="props" label="Title" field="title">
        <router-link title="Edit KB" :to="{ name: 'website-knowledgebase-edit', params: { id: props.row._id } }">{{ props.row.title }}</router-link>
      </b-table-column>
      <b-table-column v-slot="props" label="Created At" field="createdAt">
        {{ props.row.createdAt }}
      </b-table-column>
      <b-table-column v-slot="props" label="Published" field="published">
        {{ props.row.published }}
      </b-table-column>
    </b-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'WebsiteKnowledgebaseList',
  props: {
    subMenu: {
      type: String,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      knowledgebases: 'websiteNew/knowledgebases',
      loadingAction: 'websiteNew/loadingAction'
    })
  },
  mounted() {
    this.getKnowledgebases({});
  },
  methods: {
    ...mapActions({
      getKnowledgebases: 'websiteNew/getKnowledgebases'
    })
  }
};
</script>
